import { Percent } from "@silo/types";
import { asWholePercent, normalizeToPoints } from "@silo/utils";
import { cn } from "../../utils/class-names";

interface BorrowingPowerUsedProps {
  className?: string;
  borrowingPowerUsed: Percent;
}

export function BorrowingPowerUsed({
  className,
  borrowingPowerUsed,
}: BorrowingPowerUsedProps): JSX.Element {
  const points = normalizeToPoints(borrowingPowerUsed);

  return (
    <div className={cn("flex flex-col gap-6", className)}>
      <div className="flex justify-between text-white">
        <span className="text-shale-200">Borrowing power used</span>
        <div className="font-mono font-medium" data-cy="borrowing-power">
          {asWholePercent(borrowingPowerUsed)}
        </div>
      </div>

      <div className="h-2.5 bg-shale-750 rounded-full">
        <div
          className="h-2.5 bg-blue-400 rounded-full min-w-[10px] transition-[width]"
          style={{ width: `${points.toFixed(0)}%` }}
        ></div>
      </div>
    </div>
  );
}
